import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({ locale: 'page/locale' }),
  },

  methods: {
    updateOrderInSalesforce(email) {
      if (this.emailSentToSalesforce != email && On.helpers.validateEmail(email)) {
        this.$http
          .post(`/${this.locale}/orders/to-salesforce?email=${email}`)
          .then(() => (this.emailSentToSalesforce = email))
      }
    },
  },
}
